export default __webpack_public_path__ + "static/media/landing.18dd492f.png";